'use strict';

angular.module('ClinicApp').directive('onboardForm', function($q, GrowlService, UserService, CurrentUser, SignableDocumentsConstants, ClinicConfig) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_onboard-form.html',
    scope: {
      success: '&',
    },
    link: function($scope) {
      loadUser();
      $scope.config = ClinicConfig;

      $scope.onboard = function() {
        if (!$scope.user.password
          || !$scope.user.passwordConfirm
          || !$scope.user.firstName
          || !$scope.user.lastName
          || !$scope.user.jobTitle
        ) {
          GrowlService.error('All fields must be provided.');
          return $q.reject();
        }
        if ($scope.user.password != $scope.user.passwordConfirm) {
          GrowlService.error('Passwords provided do not match.');
          return $q.reject();
        }
        return UserService.onboard($scope.user.email, $scope.user.password, $scope.user.firstName, $scope.user.lastName, $scope.user.jobTitle, _.map($scope.signableDocuments, 'type')).then(function() {
          $scope.success();
        });
      };

      function loadUser() {
        return CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function(user) {
          $scope.user = user;
          var country = _.get(user, 'editable.clinics[0].address.country', 'United States');
          $scope.signableDocuments = SignableDocumentsConstants[country];
        });
      }
    },
  };
});
